export default "__VITE_ASSET__CBsJfQmJ__"